<template>

  <h2>Arming, Security, and Documents for Person</h2>

  <RouterLinkButton mode="backButton"></RouterLinkButton>

  <PersonInfoComponent v-if="myPersonInfo != null" :person-object="myPersonInfo">
      <template v-slot:footer>
          <span tabindex="0">See the options below to edit this person's arming, security, and documents.</span>
      </template>
  </PersonInfoComponent>

  <PersonWeaponTable v-if="myPersonInfo != null" :person-id="personId"></PersonWeaponTable>
  
  <AdminPersonEditForm v-if="myPersonInfo != null" :person-id="personId"></AdminPersonEditForm>

  <PersonDocumentTable></PersonDocumentTable>
  <DocComponent v-if="myPersonInfo != null" :PersonId="personId"  :ContractId="myPersonInfo.contractId"></DocComponent>

</template> 
  
<script> 

  import RouterLinkButton from '../helpers/RouterLinkButton.vue';
  import AdminPersonEditForm from "@/components/ProcessMasterListViews/AdminEditPersonForm.vue";
  import PersonDocumentTable from './PersonDocumentTable.vue';
  import PersonWeaponTable from './PersonWeaponTable.vue';
  import PersonInfoComponent from './PersonInfoComponent.vue';
  import DocComponent from "@/components/dataSupport/DocCmp.vue"; 
  import {ajaxGetAndReturn} from "@/components/helpers/utilities.js";
  import { store } from "@/store/store.js";

  export default {
    name: "EditPersonPage",
    components: {
      AdminPersonEditForm,
      PersonDocumentTable,
      PersonWeaponTable,
      RouterLinkButton,
      PersonInfoComponent,
      DocComponent
    }, 
    data(){
      return{
        isMounted : false,
        myPersonInfo:null,
        store,
      }
    },
    computed:{
      personId(){
        var computedValue = 0; 

        if(this.store.tempPersonId != 0){
          computedValue = this.store.tempPersonId;
        }
        else{
          computedValue = this.$route.params.personId;
        }

        return computedValue;
      }
    },
    created(){ // called BEFORE rendering (load data here)
      ajaxGetAndReturn(store.webAPIUrl + "personContractInfo/" + this.personId, (result) =>{
          this.myPersonInfo = result; 
        });
    },
    mounted() { // called afer rendering
      this.isMounted = true; 
    },

    methods:{
      PersonUpdate(){

      }
    },
    unmounted(){ //called when the page is left or the component is destroyed

      //console.log("force update user contracts table"); 
      this.$forceUpdate();
    }
  }
</script>
  
<style scoped>

</style>
